import { useMemo } from 'react';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorScope,
  AllCollectorsQuery,
  useAllCollectorsQuery,
  Exact,
  Maybe,
  CollectorInput
} from 'graphql/types';

export const useAllCollectors = (): {
  data: AllCollectorsQuery | undefined;
  loading: boolean;
  refetch: (
    variables?:
      | any
      | Partial<
          Exact<{
            input?: Maybe<CollectorInput>;
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<AllCollectorsQuery>>;
} => {
  const { loading, data, refetch } = useAllCollectorsQuery({
    variables: {
      input: { scope: CollectorScope.All }
    }
  });

  return useMemo(
    () => ({
      loading,
      data,
      refetch
    }),
    [data, loading, refetch]
  );
};
